import { useSyncExternalStore } from 'react';

/**
 * Shared hook for detecting prefers-reduced-motion.
 * Uses useSyncExternalStore for efficient subscription to matchMedia changes.
 * No matchMedia churn on re-renders — single subscription per component instance.
 *
 * Resolves audit issues T6 (Tooltip) and O8 (Onboarding).
 * Ticket: DEV-016
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    (callback) => {
      if (typeof window === 'undefined') return () => {};
      const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
      // Modern API
      if ('addEventListener' in mql) {
        mql.addEventListener('change', callback);
        return () => mql.removeEventListener('change', callback);
      }
      // Legacy fallback (older Safari)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (mql as any).addListener(callback);
      return () => (mql as any).removeListener(callback);
    },
    () => {
      if (typeof window === 'undefined') return false;
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    () => false // SSR fallback
  );
}
